import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "layout/header";
import Footer from "layout/footer";
import PageHeader from "component/PageHeader";
import imgTop02 from "../../assets/images/img_top02.png";
import { useSearchParams } from "react-router-dom";

const Contact = () => {
  const [pageTitle] = useState("문의하기"); // 기본 타이틀

  const breadcrumb = [{ label: "홈", path: "/main" }, { label: "문의하기" }];
  const [searchParams] = useSearchParams();

  const [formData, setFormData] = useState({
    contactType: "",
    companyName: "",
    customerName: "",
    phone: "",
    email: "",
    title: "",
    message: "",
    agree: false,
  });
  useEffect(() => {
    const type = searchParams.get("type");
    const product = searchParams.get("product");

    const solutionName = {
      modelin: "ModelIN",
      linkin: "LinkIN",
      openin: "OpenIN",
      collectin: "CollectIN",
    }[product];

    let contactType = "";
    let title = "";
    let message = "";

    if (type === "demo") {
      contactType = "제품 문의";
      title = `${solutionName || "솔루션"} 방문 데모 신청`;
      message = `${solutionName || "솔루션"} 방문 데모 신청`;
    } else if (type === "qna") {
      contactType = "제품 문의";
      title = `${solutionName || "솔루션"} 제품 문의`;
      message = `${solutionName || "솔루션"} 제품 문의`;
    }
    setFormData((prev) => ({
      ...prev,
      contactType,
      title,
      message,
    }));
  }, [searchParams]);

  // 유효성 검사: 모든 필드가 입력되고 동의 체크가 되었는지 확인
  const isValid = Object.values(formData).every(
    (value) => value !== "" && value !== false,
  );
  // 입력 값 변경 핸들러
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  // 폼 제출 핸들러
  const handleSubmit = async () => {
    // const {
    //   contactType,
    //   companyName,
    //   customerName,
    //   phone,
    //   email,
    //   title,
    //   message,
    // } = formData;

    // // 받는 이메일 주소
    // const recipientEmail = "info@inissoft.com";

    // // 메일 제목
    // const subject = encodeURIComponent(title);

    // // 메일 본문 (문의 내용 포함)
    // const body = encodeURIComponent(
    //   `문의 유형: ${contactType}\n` +
    //     `회사명: ${companyName}\n` +
    //     `고객명: ${customerName}\n` +
    //     `연락처: ${phone}\n` +
    //     `이메일: ${email}\n\n` +
    //     `문의 내용:\n${message}`,
    // );

    // mailto 링크 생성
    // const mailtoLink = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

    // 사용자의 메일 클라이언트 열기
    // window.location.href = mailtoLink;

    const response = await fetch("/api/mail/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      alert(
        "문의가 정상적으로 접수되었습니다. 담당자가 내용을 확인한 후 빠르게 연락드리겠습니다.",
      );
      window.dataLayer = window.dataLayer || [];
      const type = searchParams.get("type");

      window.dataLayer.push({
        event: "modelin_lead_submit",
        solution: "ModelIN",
        inquiry_type: type,
        button_name: "문의하기",
        page_path: window.location.pathname,
      });
    } else {
      alert(
        "문의가 정상적으로 접수되었습니다. 담당자가 내용을 확인한 후 빠르게 연락드리겠습니다.",
      );
      window.dataLayer = window.dataLayer || [];
      const type = searchParams.get("type");

      window.dataLayer.push({
        event: "modelin_lead_submit",
        solution: "ModelIN",
        inquiry_type: type,
        button_name: "문의하기",
        page_path: window.location.pathname,
      });
    }

    setFormData((prev) => ({
      ...prev,
      companyName: "",
      customerName: "",
      phone: "",
      email: "",
      message: "",
      agree: false,
    }));
  };

  // AOS 초기화 및 리프레시
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div id="wrap">
      <Helmet>
        <title>문의하기 | INISSOFT</title>
        <meta
          name="description"
          content="INISSOFT 문의하기 | 연계 시스템 구축, 인터페이스 개발, API 연동 등 소프트웨어 개발 관련 문의를 남겨주세요. 빠르고 정확한 답변을 드리겠습니다."
        />
        <meta
          name="keywords"
          content="INISSOFT, 아이엔아이소프트, 문의, 문의하기, CONTACT, 제휴문의, 사업문의"
        />
        <link rel="canonical" href="https://www.inissoft.com/contact" />
        <meta property="og:title" content="문의하기 | INISSOFT" />
        <meta
          property="og:description"
          content="연계 시스템 구축, 인터페이스 개발, API 연동 등 소프트웨어 개발 관련 문의를 남겨주세요."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.inissoft.com/contact" />
        <meta
          property="og:image"
          content="https://www.inissoft.com/Thumbnails.png"
        />
      </Helmet>
      <Header />
      <section className="section">
        <PageHeader
          title={pageTitle}
          backgroundImage={imgTop02}
          breadcrumb={breadcrumb.map((item) => {
            return item;
          })}
        />

        <div className="content inquire">
          <div className="container">
            <form
              className="contact-form"
              onSubmit={handleSubmit}
              data-aos="fade-up"
              data-aos-easing="ease-in-out"
              data-aos-delay="500"
            >
              <div className="form-group">
                <div className="flex-box">
                  <dl className="form-list">
                    <dt className="form-tit">문의유형</dt>
                    <dd className="form-data">
                      <div className="select-box">
                        <select
                          className="select"
                          id="contect"
                          name="contactType"
                          value={formData.contactType}
                          onChange={handleChange}
                          required
                        >
                          <option value="선택" className="">
                            선택
                          </option>
                          <option value="사업 제휴">사업 문의</option>
                          <option value="제품 문의">제품 문의</option>
                          <option value="일반 문의">일반 문의</option>
                        </select>
                      </div>
                    </dd>
                  </dl>
                </div>

                <div className="flex-box">
                  <dl className="form-list">
                    <dt className="form-tit">회사명</dt>
                    <dd className="form-data">
                      <input
                        type="text"
                        className="input"
                        id="company"
                        name="companyName"
                        placeholder="회사명을 입력해주세요"
                        value={formData.companyName}
                        onChange={handleChange}
                        required
                      />
                    </dd>
                  </dl>
                  <dl className="form-list">
                    <dt className="form-tit">고객명</dt>
                    <dd className="form-data">
                      <input
                        type="text"
                        className="input"
                        id="name"
                        name="customerName"
                        placeholder="고객명을 입력해주세요"
                        value={formData.customerName}
                        onChange={handleChange}
                        required
                      />
                    </dd>
                  </dl>
                </div>

                <div className="flex-box">
                  <dl className="form-list">
                    <dt className="form-tit">연락처</dt>
                    <dd className="form-data">
                      <input
                        type="text"
                        className="input"
                        id="tel"
                        name="phone"
                        placeholder="연락처를 입력해주세요"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </dd>
                  </dl>
                  <dl className="form-list">
                    <dt className="form-tit">이메일</dt>
                    <dd className="form-data">
                      <input
                        type="text"
                        className="input"
                        id="email"
                        name="email"
                        placeholder="답변받으실 이메일 주소를 입력해주세요."
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </dd>
                  </dl>
                </div>

                <div className="flex-box">
                  <dl className="form-list">
                    <dt className="form-tit">제목</dt>
                    <dd className="form-data">
                      <input
                        type="text"
                        className="input"
                        id="title"
                        name="title"
                        placeholder="제목을 입력해주세요"
                        value={formData.title}
                        onChange={handleChange}
                        required
                      />
                    </dd>
                  </dl>
                </div>
                <div className="flex-box">
                  <dl className="form-list">
                    <dt className="form-tit">문의 내용</dt>
                    <dd className="form-data">
                      <div className="txt-box">
                        <textarea
                          id="contents"
                          name="message"
                          placeholder="문의하시려는 내용을 입력해주세요.(500자 이내)"
                          className="textarea"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>
                    </dd>
                  </dl>
                </div>

                <div className="flex-box type-col">
                  <dl className="form-list">
                    <dt className="form-tit asterisk">개인정보 수집동의</dt>
                    <dd className="form-data">
                      <div className="terms-box">
                        <div className="terms-content">
                          <p className="terms-txt">
                            아이엔아이소프트트에서는 개인정보 수집, 이용 처리에
                            있어 아래의 사항을 정보주체에게 안내합니다.
                          </p>

                          <ul className="list-num">
                            <li>
                              개인정보 수집 및 이용목적
                              <ol className="list-dash">
                                <li>
                                  사업제휴, 제품문의, 일반문의등 고객문의 처리
                                </li>
                                <li>
                                  산업안전보건법 상 고객의 폭언 등으로 인한
                                  건강장해 예방 조치 및 제재 처리
                                </li>
                              </ol>
                            </li>

                            <li>
                              수집하는 개인정보의 항목
                              <ol className="list-dash">
                                <li>[필수] 고객명, 회사명, 연락처, 이메일</li>
                              </ol>
                            </li>

                            <li>
                              개인정보의 보유 및 이용기간
                              <ol className="list-dash">
                                <li>
                                  개인정보는 본인확인을 위한 절차로 보관 및
                                  관리되지 않습니다.
                                </li>
                              </ol>
                            </li>

                            <li>
                              개인정보 수집 및 이용에 대한 동의를 거부할 권리가
                              있습니다. 다만, 동의 거부시, 문의 접수가 불가능
                              합니다.
                              <ol className="list-dash">
                                <li>
                                  개인정보는 본인확인을 위한 절차로 보관 및
                                  관리되지 않습니다.
                                </li>
                              </ol>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </dd>
                  </dl>

                  <div className="check-box check-terms">
                    <input
                      type="checkbox"
                      id="chek01"
                      name="agree"
                      checked={formData.agree}
                      onChange={handleChange}
                    />
                    <span className="flag blue">필수</span>
                    <label htmlFor="chek01">
                      개인정보처리방침에 동의합니다.
                    </label>
                  </div>
                </div>
              </div>
            </form>

            <div className="btn-group">
              <button
                type="button"
                className="btn main"
                onClick={handleSubmit}
                disabled={!isValid}
              >
                문의하기
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
